import SessionEvent from './SessionEvent.js';
import {loadEventFromJson} from './loadEventFromJson.js';

class CompoundEvent extends SessionEvent {
    constructor(initialSubEvent) {
        super();
        this.initialSubEvent = initialSubEvent;
        this.initialSubEvent.parentEvent = this;
        this.subEvents = [];
        this.cache = {};
    }

    setTime(time, step) {
        super.setTime(time, step);

        this.initialSubEvent.setTime(time, step);
    }

    getNextSubEvent(event) {
        for (let i in this.subEvents) {
            if (event.step < this.subEvents[i].step) {
                return this.subEvents[i];
            }
        }
        return undefined;
    }

    getPreviousSubEvent(event) {
        let previous;
        for (let i in this.subEvents) {
            if (event === this.subEvents[i]) {
                return previous;
            }

            previous = this.subEvents[i];
        }

        return undefined;
    }

    isLastSubEvent(subEvent) {
        let index = this.subEvents.indexOf(subEvent);
        return index === this.subEvents.length - 1;
    }

    deleteSubEvent(event) {
        if (this.initialSubEvent === event) {
            if (this.subEvents.length === 0) {
                this.initialSubEvent = undefined;
                return 0;
            }

            this.initialSubEvent = this.subEvents[0];
            this.subEvents = this.subEvents.slice(1);
            this.initialSubEvent.step = this.step;
            if (this.initialSubEvent === undefined) {
                this.subEvents = [];
            }
            return 0;
        }

        let index = this.subEvents.indexOf(event);
        if (index < 0) {
            return index;
        }

        this.subEvents.splice(index, 1);
        return index;
    }

    isEmpty() {
        return this.initialSubEvent === undefined &&
            this.subEvents.length === 0;
    }

    get events() {
        return this.getSubEvents();
    }

    set events(events) {
        this.restart();
        this.initialSubEvent = events[0];
        this.subEvents = events.slice(1);
        this.calculateDurations();
    }

    restart() {
        this.cache = {};
    }

    getSubEvents() {
        let subEvents = [this.initialSubEvent, ... this.subEvents];
        let last = subEvents[subEvents.length - 1];
        if (last !== undefined) {
            last.duration = this.step + this.duration - last.step;
        }
        return subEvents;
    }

    addSubEvent(event) {
        event.parentEvent = this;
        this.subEvents.push(event);
        this.subEvents.sort((a,b) => a.step - b.step);

        let previous = this.initialSubEvent;
        for (let i in this.subEvents) {
            if (previous !== undefined) {
                previous.duration = this.subEvents[i].step - previous.step;
            }
            previous = this.subEvents[i];
        }
        let lastSubEvent = this.subEvents[this.subEvents.length - 1];
        lastSubEvent.duration = this.step + this.duration - lastSubEvent.step;
    }

    getSubEvent(step) {
        if (step in this.cache) {
            return this.cache[step];
        }

        let event = this.initialSubEvent;
        for (let i=0; i < this.subEvents.length; i++) {
            if (this.subEvents[i].step > step) {
                break;
            }
            event = this.subEvents[i];
        }

        this.cache[step] = event;
        return event;
    }

    // to be extended
    getSubType() {}

    fromJson(json, sequencerEngine) {
        super.fromJson(json, sequencerEngine);

        this.initialSubEvent = loadEventFromJson(
            json.initialSubEvent, this.getSubType(), sequencerEngine);

        if (this.initialSubEvent.step === undefined) {
            this.initialSubEvent.step = this.step;
        }

        this.initialSubEvent.parentEvent = this;

        for (let i in json.subEvents) {
            this.addSubEvent(
                loadEventFromJson(json.subEvents[i], this.getSubType(), sequencerEngine));
        }
    }

    getJson() {
        return {
            ... super.getJson(),
            subType: this.getSubType(),
            initialSubEvent: this.initialSubEvent.getJson(),
            subEvents: this.subEvents.map(
                e => e.getJson())
        };
    }

    calculateDurations() {
        if (this.isEmpty()) {
            this.duration = 0;
            return;
        }
        let subEvents = this.getSubEvents();

        let previous = undefined;
        for (let i in subEvents) {
            if (previous) {
                previous.duration = subEvents[i].step - previous.step;
            }

            previous = subEvents[i];
        }

        previous.duration = this.step + this.duration - previous.step;
    }
}

export default CompoundEvent;
